var PouchDB = require('pouchdb').default;
PouchDB.plugin(require('pouchdb-find'));
// var PouchDB = require('pouchdb');

var db_jobs_local = new PouchDB('db_jobs_local', { revs_limit: 1 });
var db_form_main_local = new PouchDB('db_form_main_local', { revs_limit: 1 });
var db_form_question_local = new PouchDB('db_form_question_local', { revs_limit: 1 });
var db_form_dropdown_local = new PouchDB('db_form_dropdown_local', { revs_limit: 1 });
var db_form_results_local = new PouchDB('db_form_results_local', { revs_limit: 1 });

export const LocalDataSetup = {
    db_jobs_local,
    db_form_main_local,
    db_form_question_local,
    db_form_dropdown_local,
    db_form_results_local
}